'use client'
import { SvgIcon, type SxProps } from '@mui/material'
import FooterLogoSvg from '@/assets/footer-logo.svg'

export function FooterLogo({ sx }: { sx?: SxProps }) {
  return (
    <SvgIcon viewBox="0 0 275 67" sx={{ width: 275, height: 67, ...(sx as object) }}>
      <FooterLogoSvg />
    </SvgIcon>
  )
}
